import { u as e } from "../../chunks/emotion-element-f0de968e.browser.esm.js";
const m = () => e();
export {
  m as useTheme
};
